<script setup>
import { InformationCircleIcon } from '@heroicons/vue/24/solid';

defineProps({
    variant: {
        type: String,
        default: 'error',
    },
});

const variantStyles = {
    info: 'bg-deep-teal-50 text-deep-teal-700',
    warning: 'bg-orange-100 text-orange-700',
    error: 'bg-sunset-orange-50 text-sunset-orange-700',
    success: 'bg-deep-teal-100 text-deep-teal-700',
};
</script>

<template>
    <div
        class="rounded-lg px-3 py-4"
        :class="variantStyles[variant]"
    >
        <div class="flex text-base text-inherit">
            <InformationCircleIcon
                class="shrink-0 size-6 text-inherit mr-1.5"
                aria-hidden="true"
            />

            <slot />
        </div>
    </div>
</template>
